// Ethraeon Systems public marketing router
// (c) S. Jason Prohaska (ingombrante) 2024-2026

import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Home } from "./pages/Home";
import { Demos } from "./pages/Demos";
import { Ethos } from "./pages/Ethos";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Docs } from "./pages/Docs";

function Nav() {
  return (
    <nav className="border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-950 sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-medium tracking-wide text-neutral-900 dark:text-neutral-50">Ethraeon</Link>
        <div className="flex gap-6 text-sm text-neutral-600 dark:text-neutral-400">
          <Link to="/demos" className="hover:text-neutral-900 dark:hover:text-neutral-100">Demos</Link>
          <Link to="/ethos" className="hover:text-neutral-900 dark:hover:text-neutral-100">Ethos</Link>
          <Link to="/docs" className="hover:text-neutral-900 dark:hover:text-neutral-100">Docs</Link>
          <Link to="/about" className="hover:text-neutral-900 dark:hover:text-neutral-100">About</Link>
          <Link to="/contact" className="hover:text-neutral-900 dark:hover:text-neutral-100">Contact</Link>
        </div>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="border-t border-neutral-200 dark:border-neutral-800 mt-16">
      <div className="max-w-6xl mx-auto px-6 py-8 text-sm text-neutral-500 dark:text-neutral-400 flex flex-wrap justify-between gap-4">
        <span>Ethraeon Systems &middot; Humanitas ante Machinam</span>
        <span>Copyright S. Jason Prohaska (ingombrante) 2024-2026</span>
      </div>
    </footer>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demos" element={<Demos />} />
        <Route path="/ethos" element={<Ethos />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/docs" element={<Docs />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
